import { render, staticRenderFns } from "./LoanWriteOff.vue?vue&type=template&id=a7f66040"
import script from "./LoanWriteOff.vue?vue&type=script&lang=js"
export * from "./LoanWriteOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports